import { Component, Input } from '@angular/core';
import { IAnnotation, AnnotationType } from '../../../models/iannotation';

@Component({
    selector: 'global-annotations',
    templateUrl: './global-annotations.component.html',
    styleUrls: ['./global-annotations.component.css'],
})
export class GlobalAnnotationsComponent {
    // data members

    private _annotations: Array<IAnnotation> | null = null;
    get annotations() {
        return this._annotations;
    }
    @Input()
    set annotations(annotations) {
        if (
            annotations !== null &&
            annotations.filter((annotation) => annotation.type == AnnotationType.VALUE).length < 14
        ) {
            let lastValidIndex = annotations.filter((annotation) => annotation.type == AnnotationType.VALUE).length - 1;

            for (let i = lastValidIndex + 1; i < 14; i++) {
                annotations.push({
                    mappedName: annotations[lastValidIndex].mappedName,
                    detail: annotations[lastValidIndex].detail,
                    type: annotations[lastValidIndex].type,
                    markers: annotations[lastValidIndex].markers,
                    name: annotations[lastValidIndex].name,
                    value: annotations[lastValidIndex].value,
                    udM: annotations[lastValidIndex].udM,
                });
            }
        }

        this._annotations =
            annotations !== null ? annotations.filter((annotation) => annotation.type == AnnotationType.VALUE) : null;
    }
}
